import { Action, createReducer, on } from '@ngrx/store';
import { valueHelpersFailed, valueHelpersLoaded, valueHelpersLoadedFromStorage } from '../actions/value-helper.actions';
import {
    initialValueHelperCollectionState,
    ValueHelperCollectionState,
    ValueHelperState,
} from '../value-helper-collection.state';
import { LoadStatus } from '../../load-status';

const setModelsReducer = (
    state: Readonly<ValueHelperCollectionState>,
    { valueHelpers }: { valueHelpers: ValueHelperState[] },
): Readonly<ValueHelperCollectionState> => ({
    ...state,
    valueHelpers,
    status: LoadStatus.Loaded,
});

const createValueHelperReducer = createReducer(
    initialValueHelperCollectionState,
    // Both the backend load and the storage rehydrate populate the slice identically; they are
    // distinct actions only so the persist effect fires for the backend load, not the rehydrate.
    on(valueHelpersLoaded, valueHelpersLoadedFromStorage, setModelsReducer),
    on(valueHelpersFailed, (state) => ({ ...state, status: LoadStatus.Error })),
);

export function valueHelperReducer(
    state: Readonly<ValueHelperCollectionState> | undefined,
    action: Action,
): Readonly<ValueHelperCollectionState> {
    return createValueHelperReducer(state, action);
}
